/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { AuthModule } from './@auth/auth.module';
import { FormsModule } from '@angular/forms';
import { NbAccordionModule, NbCardModule, NbIconModule } from '@nebular/theme';
import { FirstCancelModule } from "./pages/paymentrequests/FirstCancel.module";
import { FirstFailureModule } from "./pages/paymentrequests/FirstFailure.module";

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,

} from '@nebular/theme';
import { AgentDashboardModule } from './pages/agent/agent-dashboard/AgentDashboard.module';
import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { SafePipeModule } from 'safe-pipe';
import { ConfirmationService } from 'primeng/api';
import { NetworkService } from './@core/utils/network.service';
import { ApiInterceptor } from './@core/utils/apiIntercepter';



@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FirstCancelModule,
    FirstFailureModule,
    AgentDashboardModule,
    FormsModule,
    NbCardModule,
    NbIconModule,
    NbAccordionModule,
    AgentDashboardModule,
    NgImageFullscreenViewModule,


    AuthModule.forRoot(),
    NbDatepickerModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [ConfirmationService,
    NetworkService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    }
  ],
})
export class AppModule {
}
